import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=5edd1f90&scoped=true"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=5edd1f90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd1f90",
  null
  
)

export default component.exports